import React from 'react';
import {EditDialog} from '../../../../components/edit-dialog/edit_dialog';
import {
    Button,
    DialogActions,
    DialogTitle,
    withStyles,
    DialogContent,
    Grid,
    Typography,
} from 'material-ui';
import {styles} from '../../style/staff_section';
import AddPageTagsSelect from './page_tags_edit';

class PageTagsPopup extends React.Component {
    render() {
        let {
            classes,
            onHandleSubmit,
            onHandleClose,
            onUpdatePageTags,
            onMultipleTagsUpdate,
            allPageTags,
            loading,
            pageTagsForDisplay,
            hasError,
            pageId,
        } = this.props;

        let selectHasError = (selected, name) => {
            let selectError = {};

            if (selected !== undefined) {
                if (selected.toString().length < 1) {
                    selectError = {[name]: true};
                }

                if (selected.toString().length > 0) {
                    selectError = {[name]: false};
                }
            }

            return selectError[name];
        };

        let error = false;
        error =
            Object.values(this.props.metaError).find(
                (element) => element === true
            ) !== undefined
                ? true
                : false;

        error =
            this.props.metaError && this.props.metaError['all'] ? false : error;

        return (
            !loading && (
                <EditDialog
                    open={this.props.open}
                    classes={{
                        paper: classes.pageTagsPaper,
                        fullWidth: classes.fullWidth,
                    }}
                >
                    <DialogTitle>Edit Page Tags</DialogTitle>
                    <DialogContent>
                        <Grid container>
                            <Grid item xs={12}>
                                <Typography variant="subheading" gutterBottom>
                                    Select Tags:
                                </Typography>
                                <AddPageTagsSelect
                                    allPageTags={allPageTags}
                                    onUpdatePageTags={onUpdatePageTags}
                                    onMultipleTagsUpdate={onMultipleTagsUpdate}
                                    pageTagsForDisplay={pageTagsForDisplay}
                                    selectHasError={selectHasError}
                                    hasError={hasError}
                                    pageId={pageId}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className={classes.dialogActionsBtn}>
                        <Button
                            variant="raised"
                            onClick={(ev) => onHandleClose(ev)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="raised"
                            onClick={(ev) => onHandleSubmit(ev)}
                            color="primary"
                            disabled={error}
                        >
                            Done
                        </Button>
                    </DialogActions>
                </EditDialog>
            )
        );
    }
}

export default withStyles(styles)(PageTagsPopup);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/page_tags_popup.js